"use client";

import React, { useEffect } from "react";
import SideNav from "../SideNav";
import AboutPremiumContent from "../AboutPremiumContent/AboutPremiumContent";
import ProgressBar from "@/components/ProgressBar";
import { useParams } from "next/navigation";
import { useSelector } from "react-redux";
import useAppDispatch from "@/app/hooks/useAppDispatch";
import { fetchAboutSectionByName, fetchAboutMenus } from "@/store/aboutPremiumSlice";

import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const PremiumMethodologySectionPage = () => {
  // Get section from route params
  const params = useParams();
  const sectionName = params?.section as string;

  // Get data from Redux store
  const dispatch = useAppDispatch();
  const menus = useSelector((state: any) => state.aboutPremium?.menus || []);
  const sections = useSelector(
    (state: any) => state.aboutPremium?.sections || null
  );
  const sectionsLoading = useSelector(
    (state: any) => state.aboutPremium?.sectionsLoading
  );
  // Set section name when menu data or section changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        if(!menus || menus.length === 0) {
          await dispatch(fetchAboutMenus());
        }
        await dispatch(fetchAboutSectionByName(sectionName));
      } catch (error) {
        console.error("Error fetching section data:", error);
      }
    };
    fetchData();
  }, [dispatch, sectionName]);

  const getNextMenuLink = () => {
    const currentIndex = menus.findIndex(
      (menu: any) => menu.name === sectionName
    );
    const nextMenu = menus[currentIndex + 1];
    return nextMenu ? `/premium-methodology/${nextMenu.name}` : "/premium-methodology";
  };

  const getNextMenuTitle = () => {
    const currentIndex = menus.findIndex(
      (menu: any) => menu.name === sectionName
    );
    const nextMenu = menus[currentIndex + 1];
    return nextMenu ? nextMenu.header : "";
  };

  const isLastSection = () => {
    const currentIndex = menus.findIndex(
      (menu: any) => menu.name === sectionName
    );
    return currentIndex === menus.length - 1;
  };

  return (
    <>
      <div className="absolute top-0 left-0 right-0 z-[1000]">
        <ProgressBar loading={sectionsLoading} />
      </div>

      <SideNav
        currentPath={`/premium-methodology/${sectionName}`}
        options={menus.map((item: any) => ({
          to: `/premium-methodology/${item.name}`,
          value: item.header,
        }))}
      >
        {!sectionsLoading ? (
          <>
            <AboutPremiumContent
              content={sections?.content}
              sectionName={sections?.header || ""}
            />
            {!isLastSection() && (
              <div className="!mt-8 !py-2.5 !px-[1.1rem] !bg-[#f5f5f5]">
                <Link
                  href={getNextMenuLink()}
                  className="!text-[#196ecf] !no-underline hover:!underline"
                >
                  <span>Next: {getNextMenuTitle() }</span><FontAwesomeIcon icon={faChevronRight} className="!ml-2 text-xs" />
                </Link>
              </div>
            )}
          </>
        ) : null}
      </SideNav>
    </>
  );
};

export default PremiumMethodologySectionPage;
